// @flow

const keywordDetailsDialogStyles = {
  processLegend: (theme) => ({
    textAlign: 'center'
  }),
  dialogPaperCtr: (theme) => ({
    minHeight: 480,
    minWidth: 500
  }),
  dialogContentCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative'
  }),
  arrowIcon: (theme) => ({
    position: 'relative',
    fontSize: 52,
    opacity: '25%'
  }),
  textField: (theme) => ({
    '& label.MuiInputLabel-shrink': {
      transform: 'translate(24px, -5px) scale(0.75)'
    }
  }),
  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem'
  }),
  iconButton: (theme) => ({
    float: 'left'
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(1),
    color: '#f44336 !important'
  }),
  actionsCtr: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 24px 0px 24px',
    paddingTop: 0
  }),
  ctaCtr: (theme) => ({
    display: 'flex'
  }),
  smallMarginLeft: (theme) => ({
    marginLeft: theme.spacing(1)
  }),
  actionAttachImgBtn: (theme) => ({
    // backgroundColor: theme.palette.primary.lighter
  }),
  warning: (theme) => ({
    color: '#f44336'
  }),
  dialogFormCtr: (theme) => ({
    // if you had a similar style for the <form> container
    display: 'flex',
    flexDirection: 'column'
  })
};

export default keywordDetailsDialogStyles;